<template>
  <div class="table-box card-base box grow" id="table-wrapper">
    <el-pagination
      :small="pagination.small"
      :current-page.sync="pagination.page"
      :page-sizes="pagination.sizes"
      :page-size.sync="pagination.size"
      :layout="pagination.layout"
      :total="total"
      :hide-on-single-page="true"
    ></el-pagination>
    <el-table
      :data="listInPage"
      style="width:100%"
      ref="summary"
      :cell-style="{padding:'4px'}"
      stripe
      header-row-class-name="fs-12"
      :empty-text="$t('invoices.noInvoices')"
      :default-expand-all="showDetail">
      <el-table-column :label="$t('invoices.invoiceDate')" prop="date" width="120">
        <template slot-scope="scope" >
          <span>{{_moment(scope.row.date)}}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('invoices.invoiceNumber')" prop="inv_number" width="160">
        <template slot-scope="scope">
          <PortausLink :id="scope.row.id" :label="scope.row.inv_number" path="/invoices/" :underline="true"></PortausLink>
        </template>
      </el-table-column>
      <el-table-column :label="$t('invoices.customer')" v-if="showCustomer">
        <template slot-scope="scope">
          <PortausLink :id="scope.row.customer.id" :label="customerName(scope.row.customer.name,scope.row.customer.usual_name)" path="/customers/" :underline="true"></PortausLink>
        </template>
      </el-table-column>
      <el-table-column :label="$t('common.status')">
        <template slot-scope="scope">
          <el-tag :type="getInvoiceTagType(scope.row.status)" size="small"> {{$t("invoices.statuses."+scope.row.status.code)}}</el-tag>
        </template>
      </el-table-column>

      <el-table-column :label="$t('invoices.subTotal')">
        <template slot-scope="scope">
          {{ formatAmount(scope.row.sub_total, scope.row.currency.code) }}
       
        </template>
      </el-table-column>
      <el-table-column :label="$t('invoices.rebate')">
        <template slot-scope="scope">
          <span v-if="scope.row.discount != null"> {{ formatAmount(scope.row.discount.amount, scope.row.currency.code) }}</span>
          <span v-else> -- </span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('invoices.total')">
        <template slot-scope="scope">
          {{$n(scope.row.total,'currency',scope.row.currency.code)}}
        </template>
      </el-table-column>
      <el-table-column :label="$t('common.dueDate')">
        <template slot-scope="scope">
          <span>{{_moment(scope.row.due_date != null ?scope.row.due_date : scope.row.dueDate)}}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('invoices.paidAmound')">
        <template slot-scope="scope">
          {{$n(scope.row.balance != null ? scope.row.balance.paid : scope.row.total_paid,'currency',scope.row.currency.code)}}
        </template>
      </el-table-column>
      <el-table-column :label="$t('invoices.creditedAmount')">
        <template slot-scope="scope">
          {{$n(scope.row.balance != null ? scope.row.balance.credited : scope.row.total_credited,'currency',scope.row.currency.code)}}
        </template>
      </el-table-column>
      <el-table-column :label="$t('invoices.outstandingAmount')">
        <template slot-scope="scope">
            {{$n(scope.row.balance != null ? scope.row.balance.outstanding : scope.row.outstanding,'currency',scope.row.currency.code)}}
        </template>
      </el-table-column>
      <el-table-column type="expand">
        <template slot-scope="props">
          <div class="mt-30">
            <div  style="line-height:18px;float:left;">
              <span class="fs-12"><strong>{{$t('invoices.invoiceNumberField')}}</strong><PortausLink :id="props.row.id" :label="props.row.inv_number" path="/invoices/" :underline="true"></PortausLink></span>
              <span class="fs-12"><br><strong>{{$t('invoices.customerField')}}</strong> <PortausLink :id="props.row.customer.id" :label="customerName(props.row.customer.name,props.row.customer.usual_name)" path="/customers/" :underline="true"></PortausLink></span>
              <span class="fs-12" v-if="props.row.rep"><br><strong>{{$t('invoices.repField')}}</strong> {{props.row.rep.firstName}} {{props.row.rep.lastName}}</span>
              <span class="fs-12" v-if="props.row.date"><br><strong>{{$t('invoices.dateField')}}</strong> {{_moment(props.row.date)}}</span>
              <span class="fs-12" v-if="props.row.sent_at"><br><strong>{{$t('invoices.sentAtField')}}</strong> {{_moment(props.row.sent_at)}}</span>
              <span class="fs-12" v-if="props.row.paid_at"><br><strong>{{$t('invoices.paidAtField')}}</strong> {{_moment(props.row.paid_at)}}</span>
            </div>
            <div  style="line-height:18px;float:right;">
              <span class="fs-12"><el-tag :type="getInvoiceTagType(props.row.status)" style="margin-left:10px;"> {{$t("invoices.statuses."+props.row.status.code)}}</el-tag></span>
            </div>
          </div>
          <el-table :data="props.row.lines" style="width:100%" ref="summary" :cell-style="{padding:'4px'}" stripe header-row-class-name="fs-12">
            <el-table-column  align="left" :label="$t('invoices.description')" prop="product.name">
              <template slot-scope="scope">
                <span class="fs-12 secondary-text">{{scope.row.product.name}}<span v-if="scope.row.product.provider!=null">, {{scope.row.product.provider.name}}</span></span>
                <span class="fs-11 secondary-text"><br>{{scope.row.description}}</span>
              </template>
            </el-table-column>
            <el-table-column  align="center" :label="$t('invoices.price')">
              <template slot-scope="scope">
                <span class="fs-12 secondary-text" v-for="(p, index) in scope.row.prices" :key="index">
                  <span v-if="p.takeAccountIntoCalculation!=false">{{$n(p.price,'currency',props.row.currency.code)}}</span>
                </span>
              </template>
            </el-table-column>
            <el-table-column  align="center" prop="qty_ordered" :label="$t('invoices.quantity')">
              <template slot-scope="scope">
                <span class="fs-12 secondary-text">{{scope.row.qty_ordered}}</span>
              </template>
            </el-table-column>
            <el-table-column  :label="$t('invoices.rebate')" width="150" align="center">
              <template slot-scope="scope">
                <span v-if="scope.row.discount == null || (scope.row.discount != null && (scope.row.discount.amount === 0 || scope.row.discount.amount == null))"> -- </span>
                <span v-else>
                  <span v-if="scope.row.discount != null && scope.row.discount.type==1" class="fs-12 secondary-text">{{scope.row.discount.value}}%</span>
                  <span v-else>
                    <span v-if="scope.row.discount != null && scope.row.discount.netType=='UNIT'" class="fs-12 secondary-text">{{scope.row.discount.value}}$ / b.</span>
                    <span v-else class="fs-12 secondary-text">{{scope.row.discount.amount}}$</span>
                  </span>
                </span>

              </template>
            </el-table-column>
            <el-table-column  align="right" prop="sub_total" :label="$t('invoices.subTotal')">
              <template slot-scope="scope">
                <span class="fs-12 secondary-text">{{$n(scope.row.sub_total_brut,'currency',props.row.currency.code)}}</span>
                <span v-if="scope.row.discount!=null && scope.row.discount.amount!=null" class="fs-12  secondary-text" ><br>({{$n(scope.row.discount.amount,'currency')}}) </span>
              </template>
            </el-table-column>
          </el-table>
          <el-row class="text-right">
            <table style="width:400px;margin-top:20px;float:right;" v-if="props.row">
                <tr>
                  <td class="fs-12 secondary-text font-weight-800" style="text-align:right;">{{$t('invoices.subTotalField')}}</td>
                  <td class="fs-12 secondary-text font-weight-800" style="text-align:right;width:150px;">{{$n(props.row.sub_total,'currency',props.row.currency.code)}}</td>
                </tr>
                <tr v-if="props.row.discount != null">
                  <td class="fs-12 secondary-text font-weight-800" style="text-align:right;">{{$t('invoices.rebateField')}}</td>
                  <td class="fs-12 secondary-text font-weight-800" style="text-align:right;width:150px;">{{$n(props.row.discount.amount,'currency',props.row.currency.code)}}</td>
                </tr>
                <tr v-for="(tax, index) in props.row.taxes" :key="index">
                  <td class="fs-12 secondary-text" style="text-align:right;">{{tax.name || tax.label}} ({{tax.number || tax.taxNumber}}) : </td>
                  <td class="fs-12 secondary-text" style="text-align:right;width:150px;">{{$n(tax.total,'currency',props.row.currency.code)}}</td>
                </tr>
                <tr>
                  <td class="fs-12 secondary-text font-weight-800" style="text-align:right;">{{$t('invoices.totalField')}}</td>
                  <td class="fs-12 secondary-text font-weight-800" style="text-align:right;width:150px;">{{$n(props.row.total,'currency',props.row.currency.code)}}</td>
                </tr>
                <tr v-if="props.row.total_credited > 0">
                  <td class="fs-12 secondary-text" style="text-align:right;">{{$t('invoices.creditsApplied')}}</td>
                  <td class="fs-12 secondary-text" style="text-align:right;width:150px;">{{$n(props.row.total_credited,'currency',props.row.currency.code)}}</td>
                </tr>
                <tr >
                  <td class="fs-12 secondary-text" style="text-align:right;">{{$t('invoices.paidAmound')}}</td>
                  <td class="fs-12 secondary-text" style="text-align:right;width:150px;">{{$n(props.row.total_paid,'currency',props.row.currency.code)}}</td>
                </tr>
                <tr>
                  <td class="fs-12 secondary-text font-weight-800" style="text-align:right;">{{$t('invoices.outstandingAmountField')}}</td>
                  <td class="fs-12 secondary-text font-weight-800" style="text-align:right;width:150px;">{{$n(props.row.outstanding,'currency',props.row.currency.code)}}</td>
                </tr>
            </table>
          </el-row>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      :small="pagination.small"
      :current-page.sync="pagination.page"
      :page-sizes="pagination.sizes"
      :page-size.sync="pagination.size"
      :layout="pagination.layout"
      :total="total"
      :hide-on-single-page="true"
    ></el-pagination>
  </div>
</template>
<script>
import moment from 'moment'
import { mapActions, mapState, mapGetters } from 'vuex';
import PortausLink from '@/components/portaus-link'
import CustomerUtil from '@/utils/customer-util'
import portausUtils from '@/utils/portaus-utils';

export default {
	name: 'Invoices-summary',
  props : {
    invoices : {
        type : Array,
        default : () => []
      },
    showCustomer : {
      type : Boolean,
      default : true
    },
    showDetail : {
      type: Boolean,
      default: false,
    },
    detailed : {
      type : Boolean,
      default : false
    }
  },
  data() {
    return {
      pagination: {
				page: 1,
				size: 20,
				sizes: [10, 15, 20, 30, 50, 100],
				layout: 'total, ->, prev, pager, next, sizes',
				small: false
			},
    };
  },
  methods : {
    formatAmount(amount, currencyCode) {
          return portausUtils.formatAmount(amount, this.$i18n.locale, currencyCode);
		},
    customerName(name, usual_name){
      return CustomerUtil.customerName(name, usual_name);
    },
    _moment(date, format='l'){
      return moment(date).format(format);
    }
  },
	computed : {
    total() {
			return this.invoices.length
		},
    listInPage(){
      let from = (this.currentPage - 1) * this.itemPerPage
      let to = from + (this.itemPerPage*1)
      //return this.listSortered.slice(from, to)
      return this.invoices.slice(from, to)
    },
    currentPage: {
			get() {
				return this.pagination.page
			},
			set(val) {
				this.pagination.page = val
			}
		},
		itemPerPage() {
			return this.pagination.size
		},
    ...mapGetters('invoices',['getInvoiceTagType'])
	},
	components : {
    PortausLink
	}
}
</script>
<style>

</style>
